var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.diffVisible,
            title: " ",
            width: "60%",
            "modal-append-to-body": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.diffVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "diff-container" }, [
            _c("div", { staticClass: "diff-left" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", [_vm._v("修改前")]),
              ]),
              _c("div", { staticClass: "diff-left-content" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "left" }, [_vm._v("left")]),
                  _c("div", { staticClass: "right" }, [_vm._v("right")]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "diff-right" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", [_vm._v("修改后")]),
              ]),
              _c("div", { staticClass: "diff-right-content" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "left" }, [_vm._v("left")]),
                  _c("div", { staticClass: "right" }, [_vm._v("right")]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }